import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type WrongProductState = boolean;

export const WRONG_PRODUCT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<WrongProductState>>,
): ConditionType<WrongProductState, Condition.WrongProduct> => ({
  name: "Wrong product",
  description(state) {
    return "Return is for wrong product";
  },
  Details(props: ConditionTypeDetailsProps<WrongProductState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return true; // This is a flag condition, always true when present
  },
  toModel(state) {
    return { type: Condition.WRONG_PRODUCT };
  },
  valid(state) {
    return true;
  },
});
